module.exports = __webpack_public_path__ + "img/MCREDIT.5b2e3c15.svg";